import React from 'react';
import { Button } from 'src/components';

const DoneFeedbackButton = ({ onClick, type = 'button', disabled }) => (
  <Button
    type={type}
    variant='custom'
    classes='bg-[#0F172A] text-white text-base px-8 py-2 rounded-md transition-colors duration-300 h-11'
    onClick={onClick}
    disabled={disabled}
  >
    Done
  </Button>
);
export default DoneFeedbackButton;
